let routes = [
  {
    path: '/demande-attestation-neuropsy',
    component: () => import('../views/AttestationNeuropsy.vue'),
    props: true
  },
  {
    path: '/demande-attestation-neuropsy/:step',
    component: () => import('../views/AttestationNeuropsy.vue'),
    props: true
  }
]

export default routes;